import { Box, BoxProps, Container, Divider, styled, Theme, useMediaQuery, useTheme } from '@mui/material';

import { useSelector } from 'react-redux';
import { RootState } from 'redux/reducers';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useAuth } from 'context/authentication';
import { useCartService } from 'services/cart/useCartService';
import { cloudFunction, CLOUD_FUNCTIONS } from 'config/firebase/callable';
import { useRouting } from 'services/routing';
import Render from 'components/atoms/Render';
import useTranslation from 'next-translate/useTranslation';
import { keys, toPairs } from 'lodash';
import { db } from 'config/firebase';
import { getIsOpenNowForHours, isClientSide } from 'services/utils';
import UnsuccessfulPaymentPopup from './components/UnsuccessfulPaymentPopup';
import { MapMarker } from 'types/map';
import userMarker from 'assets/svg/userMarker.svg';
// import CartMap from 'components/CartMap';
import WhereTo from './WhereTo';
import WhenCart from './WhenCart';
import OrderItems from './OrderItems';
import CartFees from './CartFees';
import { useAlertDialog } from 'hooks/useAlertDialog';
import GoogleMapsApiContainer from 'containers/google-maps/GoogleMapsApiContainer';
import CartMarkerInfo from './CartMarkerInfo';
import PaymentDetails from './PaymentDetails';
import DriverComment from './DriverComment';
import * as animationData from 'assets/lottie/login.json';
import Lottie from 'react-lottie';
import LoginModal from 'containers/login/LoginModal';
import { PrimaryButton } from 'components/atoms/Buttons';
import { Payment, Restaurant } from 'klikni-jadi-shared-stuff';
import { restExecutor } from 'services/rest-executor/executor';
import CartMap from 'components/Maps/CartMap';

interface IMyCartProps {
    routerQuery: any;
}
interface StickyBoxProps extends BoxProps {
    theme?: Theme;
}

const StickyTransitionBox = styled(Box)(({ theme }: StickyBoxProps) => ({
    transition: theme.transitions.create(['height', 'top'], {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
    }),
}));

const MyCartV2 = ({ routerQuery }: IMyCartProps) => {
    const { isInitialised, isAuthenticated } = useAuth();
    const userCart = useSelector((state: RootState) => state.userCart).data;
    const [openLogin, setOpenLogin] = useState<boolean>(false);
    const user = useSelector((state: RootState) => state.currentUser);
    const cartService = useCartService();
    const [orderProcessing, setOrderProcessing] = useState<boolean>(false);
    const routing = useRouting();
    const [noPaymentType, setNoPaymentType] = useState<boolean>(false);
    const [errorPlacingOrder, setErrorPlacingOrder] = useState<string>(null);
    const [paymentFormValues, setPaymentFormValues] = useState<any>(null);
    const preorderRef = useRef(false);
    const { isLoaded } = useSelector((state: RootState) => state.mapInfo.data);
    const orderPriceRef = useRef(0);
    const [distance, setDistance] = useState<string>('');
    const [safeKey, setSafeKey] = useState<string>('');
    const { t } = useTranslation('common');
    const { addPreorder, addCustomerChange, getFinalCartPrice, addDriverComment, addPayment } = useCartService();
    const [customerChange, setCustomerChange] = useState<string>('');
    // const [onlineFee, setOnlineFee] = useState<number>(null);
    const [markers, setMarkers] = useState<any[]>([]);
    const [restaurantIds, setRestaurantIds] = useState<string[]>([]);
    const [onlyPayCash, setOnlyPayCash] = useState<boolean>(false);
    const [onlyPayOnline, setOnlyPayOnline] = useState<boolean>(false);
    const formEl = useRef(null);
    const [markerProps, setMarkerProps] = useState<any[]>([]);
    const theme = useTheme();
    const matched = useMediaQuery(theme.breakpoints.down('md'));
    const [onlyPreorder, setOnlyPreorder] = useState<boolean>(false);

    const commentTimeout = useRef(null);

    useEffect(() => {
        if (userCart) {
            if (userCart.customerChange) {
                setCustomerChange(userCart.customerChange.toString());
            } else {
                setCustomerChange(getFinalCartPrice().toString());
            }
        }
    }, [userCart?.customerChange]);

    useEffect(() => {
        if (paymentFormValues && formEl.current) {
            // formEl.current.submit();
        }
    }, [paymentFormValues]);
    useEffect(() => {
        if (userCart?.groupedItems) {
            const _keys = keys(userCart?.groupedItems);
            if (_keys?.length !== restaurantIds.length) {
                setRestaurantIds(_keys);
            } else {
                if (_keys.some(k => !restaurantIds.includes(k))) {
                    setRestaurantIds(_keys);
                }
            }
        }
    }, [userCart?.groupedItems]);

    // const restaurantIds = useMemo(() => {
    //     return keys(userCart.groupedItems);
    // }, [userCart.groupedItems]);

    // useEffect(() => {
    //     if (userCart?.groupedItems && Object.values(userCart?.groupedItems)?.[0]?.region) {
    //         const path = settingsPath(Object.values(userCart?.groupedItems)?.[0].region);
    //         db.collection(path)
    //             .doc('fees')
    //             .get()
    //             .then(res => {
    //                 setOnlineFee(res.data()?.onlineFee || 0);
    //             });
    //     }
    // }, [userCart?.groupedItems]);

    useEffect(() => {
        if (restaurantIds?.length > 0) {
            for (let index = 0; index < restaurantIds.length; index++) {
                const id = restaurantIds[index];
                db.doc(`/restaurants/${id}`)
                    .get()
                    .then(snap => {
                        const _isOpen = getIsOpenNowForHours(snap.data().workingHours);
                        setOnlyPreorder(op => op || !_isOpen);
                        const restaurant = snap.data() as Restaurant;
                        if (restaurant?.disablePayCash) {
                            addPayment('online');

                            setOnlyPayOnline(true);
                        } else if (restaurant?.disablePayOnline) {
                            if (userCart?.type === 'delivery') {
                                addPayment('cash');
                            }
                            setOnlyPayCash(true);
                        }
                    });
            }
        }
    }, [restaurantIds]);
    useEffect(() => {
        let arr = [];
        if (userCart) {
            arr = toPairs(userCart.groupedItems).map(([resId, resItem]) => ({
                position: {
                    lat: resItem?.restaurantAddress?.location?.latitude,
                    lng: resItem?.restaurantAddress?.location?.longitude,
                },
                id: resId,
                icon: resItem?.restaurantLogoUrl,
                info: resItem,
            }));

            setMarkers(arr);
        }
    }, [restaurantIds]);
    useEffect(() => {
        if (userCart?.host?.address && markers.length > 0) {
            setMarkerProps([
                ...markers,
                {
                    position: {
                        lat: userCart?.host?.address?.location?.latitude,
                        lng: userCart?.host?.address?.location?.longitude,
                    },
                    id: userCart?.host?.address?.id,
                    icon: userMarker,
                    info: null,
                    isUserMarker: true,
                },
            ]);
        }
    }, [userCart?.host?.address?.location?.latitude, userCart?.host?.address?.location?.longitude, markers]);

    const destinationProp = useMemo(() => {
        return {
            lat: userCart?.host?.address?.location?.latitude,
            lng: userCart?.host?.address?.location?.longitude,
        };
    }, [userCart?.host?.address?.location?.latitude, userCart?.host?.address?.location?.longitude]);
    const CartMapMemo = useMemo(() => {
        if (destinationProp.lat && destinationProp.lng && markerProps.length > 0) {
            return (
                <>
                    {/* <CartMap
                        markers={markerProps}
                        distanceLabel={`${userCart?.km} km`}
                        hidePin
                        setDistance={setDistance}
                        origins={markers.map((m, i) => {
                            return {
                                lat: m?.position.lat,
                                lng: m?.position.lng,
                            };
                        })}
                        destination={destinationProp}
                        // origin={originProp}
                        // destinations={origi}
                    >
                        {(marker: MapMarker<any>) => <CartMarkerInfo marker={marker} />}
                    </CartMap> */}
                    <CartMap markers={markerProps} distance={distance} setDistance={setDistance} />
                </>
            );
        }

        return null;
    }, [markerProps, destinationProp, userCart?.km, distance]);

    const callback = res => {
        if (safeKey) {
            routing.push({
                to: '/profile/orders',
                queries: {
                    'orders-view': preorderRef.current ? 'preorder' : 'active',
                    onlinePayment: 'successful',
                    orderPrice: res.total,
                },
            });
            return;
        }
        if (userCart.payment === 'cash') {
            setOrderProcessing(false);
            const view = preorderRef.current ? 'preorder' : 'active';
            preorderRef.current = false;
            routing.push({
                to: '/profile/orders',
                queries: { 'orders-view': view, orderCash: 'successful', orderPrice: orderPriceRef.current },
            });
        } else if (userCart.payment === 'online' && res) {
            setPaymentFormValues(res);
            formEl.current?.submit();
        }
    };

    const handleProceed = () => {
        if (userCart.payment || userCart.total === 0) {
            setOrderProcessing(true);
            setErrorPlacingOrder(null);
            preorderRef.current = userCart.isPreorder;
            orderPriceRef.current = cartService.getFinalCartPrice();
            const executor = restExecutor(`/carts/${userCart.id}/create-order`);

            executor
                .post({
                    data: { platform: 'web', source: 'takeaway', safeKey },
                })
                .then(response => {
                    if (response.success) {
                        if (userCart?.total === 0) {
                            setOrderProcessing(false);
                            const view = preorderRef.current ? 'preorder' : 'active';
                            preorderRef.current = false;
                            routing.push({
                                to: '/profile/orders',
                                queries: { 'orders-view': view, orderCash: 'successful', orderPrice: orderPriceRef.current },
                            });
                        }
                        if (safeKey) {
                            routing.push({
                                to: '/profile/orders',
                                queries: {
                                    'orders-view': preorderRef.current ? 'preorder' : 'active',
                                    onlinePayment: 'successful',
                                    orderPrice: response.data.total,
                                },
                            });
                            return;
                        }
                        if (userCart.payment === 'cash') {
                            setOrderProcessing(false);
                            const view = preorderRef.current ? 'preorder' : 'active';
                            preorderRef.current = false;
                            routing.push({
                                to: '/profile/orders',
                                queries: { 'orders-view': view, orderCash: 'successful', orderPrice: orderPriceRef.current },
                            });
                        } else if (userCart.payment === 'online' && response.data) {
                            setPaymentFormValues(response.data);
                            formEl.current?.submit();
                        }
                    } else {
                        console.log('error', response);
                        setOrderProcessing(false);
                        setErrorPlacingOrder(response?.data?.details?.message || response?.message);
                    }
                });

            // cloudFunction(
            //     CLOUD_FUNCTIONS.GENERATE_ORDER,
            //     {
            //         cartId: cartService.cartId,
            //         payment: userCart.payment,
            //         refund: 'no',
            //         platform: 'web',
            //         service: 'kjd',
            //         driverComment: userCart.driverComment || '',
            //         safeKey,
            //     },
            //     callback,
            //     err => {
            //         console.log('error', err);
            //         setOrderProcessing(false);
            //         setErrorPlacingOrder(err.message);
            //         alert({
            //             title: `${t('error')}`,
            //             description: err.message,
            //             // cancelText: t('no'),
            //             // successText: t('yes'),
            //             successColor: 'primary',
            //             cancelColor: 'error',
            //         });
            //     }
            // );
        } else {
            setNoPaymentType(true);

            const elem = document.getElementById('paymentContainer');

            if (elem) {
                window.scrollTo({
                    top: elem.offsetTop - 220,
                    left: window.scrollX,
                    behavior: 'smooth',
                });
            }
        }
    };

    const handlePreorderChange = async (preorderDate, isPreorder) => {
        await addPreorder(preorderDate, isPreorder);
    };
    const chooseCustomerChange = () => {
        if (userCart.payment === 'cash') {
            addCustomerChange(parseInt(customerChange));
        } else {
            addCustomerChange(0);
        }
    };
    const handlePaymentType = async (type: Payment) => {
        await addPayment(type);
    };

    if (!isInitialised) return null;
    if (!isAuthenticated)
        return (
            <Box my={{ xs: 3, sm: 5, md: 7, l: 7, xl: 12 }} display="flex" flexDirection="column">
                <Box>
                    <Lottie
                        options={{
                            loop: true,
                            autoplay: true,
                            animationData: animationData,
                            rendererSettings: {
                                preserveAspectRatio: 'xMidYMid slice',
                            },
                        }}
                        height={matched ? 200 : 400}
                        width={matched ? 200 : 400}
                    />
                </Box>
                <Box mt={3} mb={6} display="flex" justifyContent="center">
                    <PrimaryButton onClick={() => setOpenLogin(true)}>{t('loginToContinue')}</PrimaryButton>
                </Box>
                <LoginModal open={openLogin} handleClose={() => setOpenLogin(false)} />
            </Box>
        );

    const handleCommentChange = (comment: string) => {
        if (commentTimeout.current) {
            clearTimeout(commentTimeout.current);
        }

        commentTimeout.current = setTimeout(() => {
            addDriverComment(comment);
        }, 500);
    };

    return (
        <Box display="flex" pb={10} flexDirection="column">
            {paymentFormValues && (
                <form ref={formEl} action={process.env.NEXT_PUBLIC_HALK_URL} id="HalkForm" method="POST">
                    <input type="hidden" name="clientid" value={paymentFormValues.clientid} />
                    <input type="hidden" name="amount" value={paymentFormValues.amount} />
                    <input type="hidden" name="oid" value={paymentFormValues.oid} />
                    <input type="hidden" name="okUrl" value={paymentFormValues.okUrl} />
                    <input type="hidden" name="failUrl" value={paymentFormValues.failUrl} />
                    <input type="hidden" name="TranType" value="Auth" />
                    <input type="hidden" name="hashAlgorithm" value="ver3" />
                    <input type="hidden" name="Instalment" value="" />
                    <input type="hidden" name="rnd" value={paymentFormValues.rnd} />
                    <input type="hidden" name="hash" value={paymentFormValues.hash} />
                    <input type="hidden" name="storetype" value="3D_PAY_HOSTING" />
                    <input type="hidden" name="refreshtime" value="3" />
                    <input type="hidden" name="lang" value="en" />
                    <input type="hidden" name="currency" value="807" />
                    <input type="hidden" name="encoding" value="UTF-8" />
                </form>
            )}
            <Box height={{ xs: '300px', md: '500px' }}>
                {/* <GoogleMapsApiContainer>{isLoaded && CartMapMemo}</GoogleMapsApiContainer> */}
                {isLoaded && CartMapMemo}
            </Box>
            <Container maxWidth="lg">
                <Box display="flex" pt={5} justifyContent="space-between" flexDirection={{ xs: 'column', md: 'row' }}>
                    {' '}
                    <Box display="flex" mr={{ xs: 0, md: 10 }} flexDirection="column" flex={1}>
                        {' '}
                        <WhereTo cart={userCart} distance={distance} />
                        <WhenCart cart={userCart} />
                        {userCart?.total > 0 && (
                            <PaymentDetails
                                cart={userCart}
                                paymentType={userCart.payment}
                                onChangePaymentType={handlePaymentType}
                                customerChange={customerChange}
                                onChangeCustomerChange={setCustomerChange}
                                error={noPaymentType}
                                onChangeError={() => setNoPaymentType(false)}
                                handleChooseCustomerChange={chooseCustomerChange}
                                onChooseCard={key => setSafeKey(key)}
                                onlyPayCash={onlyPayCash}
                                onlyPayOnline={onlyPayOnline}
                            />
                        )}
                        <Divider />
                        <OrderItems cart={userCart} />
                        <Render when={userCart?.type === 'delivery'}>
                            <DriverComment onChange={handleCommentChange} />
                        </Render>
                    </Box>
                    <StickyTransitionBox
                        width={{ xs: '100%', md: '400px', lg: '450px' }}
                        mr={2}
                        position="sticky"
                        top={180}
                        height="500px"
                        sx={{ zIndex: 1000 }}
                    >
                        <CartFees
                            paymentType={userCart.payment}
                            // onlineFee={onlineFee}
                            cart={userCart}
                            onProceed={handleProceed}
                            loading={orderProcessing}
                            error={errorPlacingOrder}
                            disabled={onlyPreorder && !userCart?.isPreorder}
                        />
                    </StickyTransitionBox>
                </Box>
            </Container>

            <Render when={routerQuery.onlinePayment === 'unsuccessful'}>
                <UnsuccessfulPaymentPopup />
            </Render>
        </Box>
    );
};

export default MyCartV2;
